import * as Yup from "yup";
import { AADHAR_VALIDATION, ALPHABETS_ONLY, ALPHABETS_ONLY_Msg, Aadhaar_Msg, ERROR_MSG, IFSC_VALIDATION, MOBILE_VALIDATION, Mobile_Msg, NUMERIC_Msg, ONLY_CAPS, ONLY_NUMERIC, PINCODE } from "./RegularExpAndVar";


export const loginValidations =
  Yup.object().shape({
    userId: Yup.string().required(ERROR_MSG).nullable(),
    userPassword: Yup.string().required(ERROR_MSG).nullable(),
  })
export const empFormValidations =
  Yup.object().shape({
    userType: Yup.string().required(ERROR_MSG).nullable(),
    regEstablishment: Yup.string().when("userType", {
      is: "Individual/Company",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    regNo: Yup.string().when(["userType", "regEstablishment"], {
      is: (userType, regEstablishment) => userType === "Individual/Company" && regEstablishment === "yes",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    isPlanApproval: Yup.string().when("userType", {
      is: "Individual/Company",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    planApproNo: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) => userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    officeDistrictCode: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
    }),

    officeMadalCode: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
    }),

    officeVillageCode: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
    }),

    officePincode: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
        // Check if value is provided and if it matches the Andhra Pradesh ranges
        if (!value) return false; // If value is null or undefined, skip this check
        const validPincodes = [
          /^5[0-9]{5}$/,  // General check for Andhra Pradesh
          /^500\d{3}$/,    // Hyderabad
          /^530\d{3}$/,    // Visakhapatnam
          /^520\d{3}$/,    // Vijayawada
          /^522\d{3}$/,    // Guntur
          /^518\d{3}$/,    // Kurnool
          /^517\d{3}$/,    // Tirupati
        ];

        return validPincodes.some((regex) => regex.test(value));
      }).nullable(),
    }),

    officeDoorNo: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
    }),

    officeAddress: Yup.string().when(["userType", "isPlanApproval"], {
      is: (userType, isPlanApproval) =>
        userType === "Individual/Company" && isPlanApproval === "yes",
      then: Yup.string().required(ERROR_MSG),
    }),

    workExecution: Yup.string().when("userType", {
      is: "Individual/Company",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    ddoCode: Yup.string().when("userType", {
      is: "DDO",
      then: Yup.string()
        .required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    ddoOfcName: Yup.string().when("userType", {
      is: "DDO",
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    ddoOfcAddress: Yup.string().when("userType", {
      is: "DDO",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),

    ddoPhoneNo: Yup.string().when("userType", {
      is: "DDO",
      then: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, Mobile_Msg).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    ddoEmail: Yup.string().when("userType", {
      is: "DDO",
      then: Yup.string().required(ERROR_MSG).nullable().email('Invalid email address').nullable(),
      otherwise: Yup.string().notRequired(),
    }),
    category: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string().required(ERROR_MSG),
      otherwise: Yup.string().notRequired(),
    }),
    nameOfDept: Yup.string().when("category", {
      is: (val) => !!val,
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    positionName: Yup.string().when('nameOfDept', {
      is: (val) => !!val,
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    agencyName: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    agencyAddress: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string()
        .required(ERROR_MSG)
        .max(10, "Maximum 10 characters allowed"),
      otherwise: Yup.string().notRequired(),
    }),

    agencyAuthPersonName: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    agencyPhnNo: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, Mobile_Msg).nullable(),
      otherwise: Yup.string().notRequired(),
    }),

    agencyEmail: Yup.string().when("userType", {
      is: "Executing Agency",
      then: Yup.string()
        .required(ERROR_MSG)
        .email("Invalid email format"),
      otherwise: Yup.string().notRequired(),
    }),

    workdetails: Yup.array().of(Yup.object().shape({
      venderName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
      workBillNo: Yup.string().required(ERROR_MSG).nullable(),
      workAddress: Yup.string().required(ERROR_MSG).nullable(),
      natureOfWork: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
      valueOfWork: Yup.string().required(ERROR_MSG).nullable(),
      phoneNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, Mobile_Msg).nullable(),
    })),
    // cessAmount: Yup.number()
    // .typeError("CESS Amount must be a number")
    // .required(ERROR_MSG),

    paymentType: Yup.string().required(ERROR_MSG).nullable(),
    paymentVendorName: Yup.string().required(ERROR_MSG).nullable(),
    // advanCessAmount: Yup.number()
    //   .when("paymentType", {
    //     is: "P",
    //     then: (schema) =>
    //       schema
    //         .typeError("Advance CESS must be a number")
    //         .required(ERROR_MSG)
    //         .min(0, "Advance CESS cannot be negative")
    //         .test("not-exceed", "Advance CESS cannot exceed total CESS", function (value, context) {
    //           const { cessAmount, RemainingAmount } = context.parent;
    //           const maxAllowed = RemainingAmount !== undefined && RemainingAmount !== null
    //             ? Number(RemainingAmount)
    //             : Number(cessAmount);

    //           return value < maxAllowed;
    //           // return value < Number(cessAmount);
    //         }),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),

      advanCessAmount: Yup.number()
      .when("paymentType", {
        is: "P",
        then: (schema) =>
          schema
            .typeError("Advance CESS must be a number")
            .required(ERROR_MSG)
            .min(0, "Advance CESS cannot be negative")

            // 🔥 Vendor-wise CESS validation
            .test(
              "not-exceed-vendor-cess",
              function (value,context) {
                const { paymentVendorName, workdetails } = context.parent;

                // No vendor selected → skip validation
                if (!paymentVendorName) return true;

                // Find vendor row
                const vendor = workdetails?.find(
                  (v) => v.venderName === paymentVendorName
                );
                if (!vendor) return true; // No vendor found → skip
                const workValue = parseFloat(vendor.valueOfWork) || 0;
                const vendorLimit = workValue * 0.01; // 1%

                if (value >= vendorLimit) {
                  return this.createError({
                    path: this.path,
                    message: `Advance CESS cannot exceed ${vendorLimit.toFixed(
                      2
                    )} for vendor ${paymentVendorName}`,
                  });
                }

                return true;
              }
            ),

        otherwise: (schema) => schema.notRequired(),
      }),


    // balancePayAmount: Yup.number()
    //   .typeError("Balance Payable Amount must be a number")
    //   .min(0, "Balance cannot be negative"),

  })
export const WorkerRegValidations =
  Yup.object().shape({
    aadhaarNo: Yup.string()
  .when('userType', {
    is: (val) => val === 'emp', 
    then: Yup.string()
      .required(ERROR_MSG)
      .matches(AADHAR_VALIDATION, Aadhaar_Msg)
      .nullable(),
    otherwise: Yup.string().nullable(),
  }),
    // aadhaarNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, Aadhaar_Msg).nullable(),
    empName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    caste: Yup.string().required(ERROR_MSG).nullable(),
    subCaste: Yup.string().required(ERROR_MSG).nullable(),
    religion: Yup.string().required(ERROR_MSG).nullable(),
    dob: Yup.string().required(ERROR_MSG).nullable(),
    workYears: Yup.string().when('dob', {
      is: (dob) => !!dob,
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    lastName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    firstName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    gender: Yup.string().required(ERROR_MSG).nullable(),
    maritalStatus: Yup.string().required(ERROR_MSG).nullable(),
    phoneNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, Mobile_Msg).nullable(),
    // fatherName: Yup.string().required(ERROR_MSG).nullable(),
    fatherName: Yup.string()
  .when('userType', {
    is: (val) => val === 'emp',
    then: Yup.string().required(ERROR_MSG).nullable(),
    otherwise: Yup.string().nullable(), 
  }),
    // .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    ifscCode: Yup.string().required(ERROR_MSG).nullable(),
    nameInBank: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    //    bankAccountNo: Yup.string().required(ERROR_MSG).matches(/^[0-9]{10,15}$/, 'Bank Account Number must be between 10 and 15 digits'),
    bankAccountNo: Yup.string()
      .required(ERROR_MSG)
      .matches(
        /^(?!.*(\d)\1{9,})(?!123456789)(?!9876543210)[0-9]{10,15}$/,
        'Bank Account Number must be 10–15 digits, not all same or sequential'
      ),
    rbankAccountNo: Yup.string().required(ERROR_MSG).oneOf([Yup.ref("bankAccountNo"), null], "Account Number doesn't match."),
    bankPhotoDesc: Yup.string().required(ERROR_MSG).nullable(),
    presentDistrictCode: Yup.string().required(ERROR_MSG).nullable(),
    presentMadalCode: Yup.string().required(ERROR_MSG).nullable(),
    presentVillageCode: Yup.string().required(ERROR_MSG).nullable(),
    presentOtherVillageName: Yup.string().when('presentVillageCode', {
      is: '0',
      then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
      otherwise: Yup.string().notRequired()
    }),
    // presentPincode: Yup.string().required(ERROR_MSG).matches(PINCODE).nullable(),
    presentPincode: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
      // Check if value is provided and if it matches the Andhra Pradesh ranges
      if (!value) return false; // If value is null or undefined, skip this check
      const validPincodes = [
        /^5[0-9]{5}$/,  // General check for Andhra Pradesh
        /^500\d{3}$/,    // Hyderabad
        /^530\d{3}$/,    // Visakhapatnam
        /^520\d{3}$/,    // Vijayawada
        /^522\d{3}$/,    // Guntur
        /^518\d{3}$/,    // Kurnool
        /^517\d{3}$/,    // Tirupati
      ];

      return validPincodes.some((regex) => regex.test(value));
    }).nullable(),
    presentDoorNo: Yup.string().required(ERROR_MSG).nullable(),
    presentAddress: Yup.string().required(ERROR_MSG).nullable(),
    presentCity: Yup.string().required(ERROR_MSG).nullable(),
    presentLandMark: Yup.string().required(ERROR_MSG).nullable(),
    presentDivision: Yup.string().required(ERROR_MSG).nullable(),
    isPermanent: Yup.string().required(ERROR_MSG).nullable(),
    permanentDistrictCode: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
    permanentMadalCode: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
    permanentVillageCode: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
    permanentOtherVillageName: Yup.string().when(
      ['permanentVillageCode', 'isPermanent'],
      {
        is: (presentVillageCode, isPermanent) => presentVillageCode === "0" && isPermanent === "N",
        then: Yup.string()
          .required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
        otherwise: Yup.string().notRequired()
      }
    ),
    permanentPincode: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG)
        .test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
          // Check if value is provided and if it matches the Andhra Pradesh ranges
          if (!value) return false; // If value is null or undefined, skip this check
          const validPincodes = [
            /^5[0-9]{5}$/,  // General check for Andhra Pradesh
            /^500\d{3}$/,    // Hyderabad
            /^530\d{3}$/,    // Visakhapatnam
            /^520\d{3}$/,    // Vijayawada
            /^522\d{3}$/,    // Guntur
            /^518\d{3}$/,    // Kurnool
            /^517\d{3}$/,    // Tirupati
          ];

          return validPincodes.some((regex) => regex.test(value));
        }), otherwise: Yup.string(),
    }),
    permanentDoorNo: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
    permanentAddress: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
     permanentDivision: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
     permanentLandMark: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
     permanentCity: Yup.string().when("isPermanent", {
      is: (isPermanent) => (isPermanent === "N" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),

    isUnionMember: Yup.string().required(ERROR_MSG),
    unionName: Yup.string().when("isUnionMember", {
      is: (isPermanent) => (isPermanent === "Y" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),
    regNo: Yup.string().when("isUnionMember", {
      is: (isPermanent) => (isPermanent === "Y" ? true : false),
      then: Yup.string().required(ERROR_MSG)
        // .matches(
        //   /^(?!.*(\d)\1{9,})(?!123456789)(?!987654321)[0-9]{9,12}$/,
        //   'Registration No must be 9–12 digits, not all same or sequential'
        // )
      , otherwise: Yup.string(),
    }),
    isNregs: Yup.string().required(ERROR_MSG),
    jobCardNo: Yup.string().when("isNregs", {
      is: (isNregs) => (isNregs === "Y" ? true : false),
      then: Yup.string().required(ERROR_MSG)
        // .matches(
        //   /^(?!.*(\d)\1{9,})(?!123456789)(?!987654321)[0-9]{9,12}$/,
        //   'Job card Number must be 9–12 digits, not all same or sequential'
        // )
      , otherwise: Yup.string(),
    }),
    wordDaysCopyDesc: Yup.string().when("isNregs", {
      is: (isNregs) => (isNregs === "Y" ? true : false),
      then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
    }),

    selfCheck: Yup.boolean().oneOf([true], ERROR_MSG).nullable(),
    presentOfficeName: Yup.string().required(ERROR_MSG).nullable(),
    typeOfWork: Yup.string().required(ERROR_MSG).nullable(),
     workCapability: Yup.string().required(ERROR_MSG).nullable(),
    officeDistrictCode: Yup.string().required(ERROR_MSG).nullable(),
    officeMadalCode: Yup.string().required(ERROR_MSG).nullable(),
    officeVillageCode: Yup.string().required(ERROR_MSG).nullable(),
    officeOtherVillageName: Yup.string().when('officeVillageCode', {
      is: '0',
      then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
      otherwise: Yup.string().notRequired()
    }),
    // officePincode: Yup.string().required(ERROR_MSG).nullable(),
    officePincode: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
      // Check if value is provided and if it matches the Andhra Pradesh ranges
      if (!value) return false; // If value is null or undefined, skip this check
      const validPincodes = [
        /^5[0-9]{5}$/,  // General check for Andhra Pradesh
        /^500\d{3}$/,    // Hyderabad
        /^530\d{3}$/,    // Visakhapatnam
        /^520\d{3}$/,    // Vijayawada
        /^522\d{3}$/,    // Guntur
        /^518\d{3}$/,    // Kurnool
        /^517\d{3}$/,    // Tirupati
      ];

      return validPincodes.some((regex) => regex.test(value));
    }).nullable(),
    officeDoorNo: Yup.string().required(ERROR_MSG).nullable(),
    officeAddress: Yup.string().required(ERROR_MSG).nullable(),
    isMigrant  : Yup.string().required(ERROR_MSG),

  // migrantDistrictCode: Yup.string().when('isMigrant  ', {
  //   is: 'Y',
  //   then: Yup.string().required(ERROR_MSG),
  //   otherwise: Yup.string().notRequired(),
  // }),

  // migrantMadalCode: Yup.string().when('isMigrant  ', {
  //   is: 'Y',
  //   then: Yup.string().required(ERROR_MSG),
  //   otherwise: Yup.string().notRequired(),
  // }),

  // migrantVillageCode: Yup.string().when('isMigrant  ', {
  //   is: 'Y',
  //   then: Yup.string().required(ERROR_MSG),
  //   otherwise: Yup.string().notRequired(),
  // }),

  // migrantOtherVillageName: Yup.string().when(['migrantVillageCode','isMigrant  '], {
  //   is: (migrantVillageCode,isMigrant  ) => migrantVillageCode === '0' && isMigrant   === 'Y',
  //   then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
  //   otherwise: Yup.string().notRequired()
  // }),

  // migrantPincode: Yup.string().when('isMigrant  ', {
  //   is: 'Y',
  //   then: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
 
  //     if (!value) return false; 
  //     const validPincodes = [
  //       /^5[0-9]{5}$/,  
  //       /^500\d{3}$/,    // Hyderabad
  //       /^530\d{3}$/,    // Visakhapatnam
  //       /^520\d{3}$/,    // Vijayawada
  //       /^522\d{3}$/,    // Guntur
  //       /^518\d{3}$/,    // Kurnool
  //       /^517\d{3}$/,    // Tirupati
  //     ];

  //     return validPincodes.some((regex) => regex.test(value));
  //   }).nullable(),
  // }),
    photoDesc: Yup.string().required(ERROR_MSG).nullable(),
    selfAffidavitDesc: Yup.string().required(ERROR_MSG).nullable(),
    aadhaarPhotoDesc: Yup.string().required(ERROR_MSG).nullable(),
    familydetails: Yup.array().of(Yup.object().shape({
      relation: Yup.string().required(ERROR_MSG).nullable(),
      memberName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
      // memberDob: Yup.date().required(ERROR_MSG).nullable(),
    memberDob: Yup.date()
  .required("Please select Date of Birth")
  .max(new Date(), "DOB cannot be in the future")
  .test(
    "minimum-age",
    "Family member must be at least 18 years old.",
    function (value) {
      if (!value) return true; // skip if empty
      const today = new Date();
      const memberDOB = new Date(value);
      let age = today.getFullYear() - memberDOB.getFullYear();
      const monthDiff = today.getMonth() - memberDOB.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < memberDOB.getDate())) {
        age--; // Adjust age if birthday hasn’t occurred yet
      }
      return age >= 18;
    }
  )
  .test(
    "relation-based-age-gap",
    function (value) {
      const contextDob = this.options.context?.dob; // Registered user's DOB
      const relationValue = this.parent?.relation;  // Current row relation

      if (!value || !contextDob || !relationValue) return true; // Skip if missing

      const memberDOB = new Date(value);
      const registeredDOB = new Date(contextDob);

      let ageGap = registeredDOB.getFullYear() - memberDOB.getFullYear();
      const monthDiff = registeredDOB.getMonth() - memberDOB.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && registeredDOB.getDate() < memberDOB.getDate())) {
        ageGap--; // Adjust age difference
      }

      // Check relation-based age gaps
      if (["1", "2"].includes(relationValue)) {
        // Mother/Father: should be at least 15 years older
        if (ageGap < 20) {
          return this.createError({
            path: this.path,
            message: "Mother/Father should be at least 20 years older than you.",
          });
        }
      } else if (["5", "6"].includes(relationValue)) {
        // Grand Father/Mother: should be at least 30 years older
        if (ageGap < 40) {
          return this.createError({
            path: this.path,
            message: "Grand Father/Mother should be at least 40 years older than you.",
          });
        }
      } else if (["8", "9"].includes(relationValue)) {
        // Daughter/Son: should be younger than registered user
        if (memberDOB <= registeredDOB) {
          return this.createError({
            path: this.path,
            message: "Daughter/Son should be younger than you.",
          });
        }
      }
      // Spouse (7), Brother (3), Sister (4): no strict age gap rule

      return true;
    }
  ),
      // memberUid: Yup.string()
      //   .required(ERROR_MSG)
      //   .matches(AADHAR_VALIDATION, Aadhaar_Msg)
      //   .test(
      //     'not-same-as-main-aadhaar',
      //     'Member Aadhaar No should not be the same as Aadhaar No.',
      //     function (value) {
      //       const aadhaarNo = this.options.context?.aadhaarNo;
      //       return !value || !aadhaarNo || value !== aadhaarNo;
      //     }
      //   ),
    memberUid: Yup.string()
  .required(ERROR_MSG)
  .matches(AADHAR_VALIDATION, Aadhaar_Msg)
  .test(
    "not-same-as-main-aadhaar",
    function (value) {
      const aadhaarNo = this.options.context?.aadhaarNo;
      const relationValue = this.parent?.relation; // get selected relation value
      const relationMap = {
        "1": "Mother",
        "2": "Father",
        "3": "Brother",
        "4": "Sister",
        "5": "Grand Father",
        "6": "Grand Mother",
        "7": "Spouse",
        "8": "Daughter",
        "9": "Son",
      };

      const relationName = relationMap[relationValue] || "Member";

      if (!value || !aadhaarNo || value !== aadhaarNo) {
        return true;
      }
      return this.createError({
        message: `${relationName} Aadhaar No should not be the same as Registered Aadhaar No.`,
      });
    }
  )
  .test(
    "unique-member-aadhaar",
    "This Aadhaar number is already used for another member.",
    function (value) {
      const allMembers = this.options.context?.familydetails || [];
      const currentIndex = this.options.index;
      if (!value || !Array.isArray(allMembers)) return true;
      const firstIndex = allMembers.findIndex(member => member?.memberUid === value);
      return firstIndex === currentIndex;
    }
  ),


      isNomine: Yup.string().required(ERROR_MSG),
      nominePer: Yup.string().when("isNomine", {
        is: (isNomine) => (isNomine === "Y" ? true : false),
        then: Yup.string().required(ERROR_MSG), otherwise: Yup.string(),
      }),
    })),
    // familydetails: Yup.array()
    // .test('sumOfNominePer', '% of Benefits in Family must be equal to 100',(value) => {
    //     if(value.filter((val => val.isNomine === "Y"))){
    //         console.log("BENEFITS",value.filter((val => val.isNomine === "Y")))
    //         const sumOfNominePer = value?.reduce((sum, item) => sum + parseInt(item?.nominePer), 0);
    //         //sumOfNominePer && sumOfNominePer === 100
    //         return true  ;
    //     }
    //     else{
    //         return false ;
    //     }
    //     })
    // .of(Yup.object().shape({
    // relation: Yup.string().required(ERROR_MSG),
    // memberName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    // memberDob: Yup.date().required(ERROR_MSG),
    // memberUid: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, Aadhaar_Msg),
    // isNomine: Yup.string().required(ERROR_MSG),
    // nominePer: Yup.string().when("isNomine", {
    //     is: (isNomine) => (isNomine === "Y" ? true : false),
    //     then: Yup.string().required(ERROR_MSG), oterwise: Yup.string(),
    //   }),          
    // })),
    // familydetails: Yup.array().of(Yup.object().shape({
    //   relation: Yup.string().required(ERROR_MSG),
    //   memberName: Yup.string().required(ERROR_MSG),
    // })),
  })
export const InWardChequeValidation =
  Yup.object().shape({
    in_ward_cheque_in_date: Yup.date().required(ERROR_MSG).nullable(),
    organisation_name: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    lr_no_and_date: Yup.date().required(ERROR_MSG).nullable(),
    dept: Yup.string().required(ERROR_MSG).nullable(),
    work_executed_at_district: Yup.string().required(ERROR_MSG).nullable(),
    date_of_recieving: Yup.date().required(ERROR_MSG).nullable(),
    by_dept: Yup.string().required(ERROR_MSG).nullable(),
    name_of_bank: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    branch: Yup.string().required(ERROR_MSG).nullable(),
    dd_cheque: Yup.string().required(ERROR_MSG).nullable(),
    cheque_no_or_ddno: Yup.string().required(ERROR_MSG).nullable(),
    date: Yup.date().required(ERROR_MSG).nullable(),
    amount: Yup.string().required(ERROR_MSG).nullable(),
    office_name: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    from_district: Yup.string().required(ERROR_MSG).nullable(),
    lr_no: Yup.string().required(ERROR_MSG).nullable(),

  })

export const InWardDBValidation =
  Yup.object().shape({
    inward_date_from: Yup.date().required(ERROR_MSG).nullable(),
    inward_date_upto: Yup.date().required(ERROR_MSG).nullable(),
  })
export const establishmentValidations =
  Yup.object().shape({
    establishmentName: Yup.string().required(ERROR_MSG).nullable(),
    postalDistrictCode: Yup.string().required(ERROR_MSG).nullable(),
    postalMadalCode: Yup.string().required(ERROR_MSG).nullable(),
    postalVillageCode: Yup.string().required(ERROR_MSG).nullable(),
    // postalPincode: Yup.string().required(ERROR_MSG).matches(PINCODE).nullable(),
    postalPincode: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
      // Check if value is provided and if it matches the Andhra Pradesh ranges
      if (!value) return false; // If value is null or undefined, skip this check
      const validPincodes = [
        /^5[0-9]{5}$/,  // General check for Andhra Pradesh
        /^500\d{3}$/,    // Hyderabad
        /^530\d{3}$/,    // Visakhapatnam
        /^520\d{3}$/,    // Vijayawada
        /^522\d{3}$/,    // Guntur
        /^518\d{3}$/,    // Kurnool
        /^517\d{3}$/,    // Tirupati
      ];

      return validPincodes.some((regex) => regex.test(value));
    }).nullable(),
    postalDoorNo: Yup.string().required(ERROR_MSG).nullable(),
    postalAddress: Yup.string().required(ERROR_MSG).nullable(),
    permanentDistrictCode: Yup.string().required(ERROR_MSG).nullable(),
    permanentMadalCode: Yup.string().required(ERROR_MSG).nullable(),
    permanentVillageCode: Yup.string().required(ERROR_MSG).nullable(),
    permanentPincode: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
      // Check if value is provided and if it matches the Andhra Pradesh ranges
      if (!value) return false; // If value is null or undefined, skip this check
      const validPincodes = [
        /^5[0-9]{5}$/,  // General check for Andhra Pradesh
        /^500\d{3}$/,    // Hyderabad
        /^530\d{3}$/,    // Visakhapatnam
        /^520\d{3}$/,    // Vijayawada
        /^522\d{3}$/,    // Guntur
        /^518\d{3}$/,    // Kurnool
        /^517\d{3}$/,    // Tirupati
      ];

      return validPincodes.some((regex) => regex.test(value));
    }).nullable(),
    permanentDoorNo: Yup.string().required(ERROR_MSG).nullable(),
    permanentAddress: Yup.string().required(ERROR_MSG).nullable(),
    managerName: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg).nullable(),
    managerEmail: Yup.string().required(ERROR_MSG).nullable().email('Invalid email address').nullable(),
    managerMobile: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, Mobile_Msg).nullable(),
    managerDistrict: Yup.string().required(ERROR_MSG).nullable(),
    managerMandal: Yup.string().required(ERROR_MSG).nullable(),
    managerVillage: Yup.string().required(ERROR_MSG).nullable(),
    managerDoorNo: Yup.string().required(ERROR_MSG).nullable(),
    // managerPincode: Yup.string().required(ERROR_MSG).nullable(),
    managerPincode: Yup.string().required(ERROR_MSG).test('is-valid-ap-pincode', 'Invalid pincode for Andhra Pradesh', (value) => {
      // Check if value is provided and if it matches the Andhra Pradesh ranges
      if (!value) return false; // If value is null or undefined, skip this check
      const validPincodes = [
        /^5[0-9]{5}$/,  // General check for Andhra Pradesh
        /^500\d{3}$/,    // Hyderabad
        /^530\d{3}$/,    // Visakhapatnam
        /^520\d{3}$/,    // Vijayawada
        /^522\d{3}$/,    // Guntur
        /^518\d{3}$/,    // Kurnool
        /^517\d{3}$/,    // Tirupati
      ];

      return validPincodes.some((regex) => regex.test(value));
    }).nullable(),
    managerAddress: Yup.string().required(ERROR_MSG).nullable(),
    establishmentCategory: Yup.string().required(ERROR_MSG).nullable(),
    natureOfConstruction: Yup.string().required(ERROR_MSG).nullable(),
    dateOfCommencement: Yup.date().required(ERROR_MSG).nullable(),
    dateOfCompletion: Yup.date().required(ERROR_MSG).nullable(),
    estCostOfConstruction: Yup.string().required(ERROR_MSG).matches(ONLY_NUMERIC, NUMERIC_Msg).nullable(),
    constructedArea: Yup.string().required(ERROR_MSG).matches(ONLY_NUMERIC, NUMERIC_Msg).nullable(),
    estimationBasis: Yup.string().required(ERROR_MSG).matches(ONLY_NUMERIC, NUMERIC_Msg).nullable(),
    planApproval: Yup.string().required(ERROR_MSG).matches(ONLY_NUMERIC, NUMERIC_Msg).nullable(),
    noOfWorkers: Yup.string().required(ERROR_MSG).matches(ONLY_NUMERIC, NUMERIC_Msg).nullable(),












  })
